import React from "react";
import { Link } from "react-router-dom";
import { useT, useLang } from "../context/LanguageContext";
import { t } from "../data/translations";

const LOAN_IMG =
    "https://images.pexels.com/photos/35704478/pexels-photo-35704478.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

const Loans = () => {
    const tr = useT();
    const { lang } = useLang();

    return (
        <div>
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 to-red-900 text-white">
                <div
                    className="absolute inset-0 opacity-25"
                    style={{ backgroundImage: `url(${LOAN_IMG})`, backgroundSize: "cover", backgroundPosition: "center" }}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/60 to-transparent" />
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">{tr(t.loans.title)}</h1>
                    <p className="mt-4 text-slate-200 max-w-2xl text-base sm:text-lg">{tr(t.loans.subtitle)}</p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
                    {t.loans.items.map((it) => (
                        <div
                            key={it.key}
                            data-testid={`loan-${it.key}`}
                            className="group bg-white rounded-xl border border-slate-200 p-6 hover:shadow-lg hover:-translate-y-1 hover:border-amber-500/50 transition-all"
                        >
                            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-red-700 to-amber-600 text-white flex items-center justify-center mb-5 shadow-sm">
                                <i className={`fa-solid ${it.icon} text-2xl`} />
                            </div>
                            <h3 className="text-lg font-bold text-slate-900 mb-1.5">{lang === "mr" ? it.mr : it.en}</h3>
                            <p className="text-sm text-slate-600 leading-relaxed mb-4">{tr(it.desc)}</p>
                            <div className="flex items-center gap-1.5 text-green-700 text-sm font-semibold">
                                <i className="fa-solid fa-check" />
                                <span>{lang === "mr" ? "त्वरित मंजुरी" : "Quick approval"}</span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA Band */}
                <div className="bg-gradient-to-r from-red-700 to-amber-600 text-white rounded-2xl p-8 sm:p-10 shadow-xl">
                    <div className="grid md:grid-cols-[1fr_auto] gap-6 items-center">
                        <div>
                            <h3 className="text-2xl sm:text-3xl font-bold mb-2">
                                {lang === "mr" ? "कर्जासाठी अर्ज करायचा आहे?" : "Need help choosing the right loan?"}
                            </h3>
                            <p className="text-amber-50 text-sm sm:text-base max-w-xl">
                                {lang === "mr"
                                    ? "आमचे तज्ज्ञ अधिकारी तुम्हाला योग्य कर्ज योजना निवडण्यात व कागदपत्रांच्या प्रक्रियेत मदत करतील."
                                    : "Our experienced loan officers will guide you through eligibility, paperwork and disbursal."}
                            </p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-3">
                            <Link
                                to="/contact"
                                data-testid="loans-apply-btn"
                                className="inline-flex items-center justify-center gap-2 bg-white text-red-700 hover:bg-amber-50 font-bold px-6 py-3.5 rounded-lg transition-colors"
                            >
                                <i className="fa-solid fa-file-pen" />
                                {tr(t.cta.applyLoan)}
                            </Link>
                            <a
                                href="tel:+919987070049"
                                className="inline-flex items-center justify-center gap-2 bg-slate-900/30 hover:bg-slate-900/50 backdrop-blur-sm border border-white/30 text-white font-semibold px-6 py-3.5 rounded-lg transition-colors"
                            >
                                <i className="fa-solid fa-phone" />
                                9987070049
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Loans;
